export default "__VITE_ASSET__CBy1h2v1__"